export default __webpack_public_path__ + "static/media/gate1.bb7b06cd.png";